export default "__VITE_ASSET__6490a4ab__"